import type { ReactNode } from 'react'
import { cn } from '@/shared/lib/cn'

interface BentoGridProps {
  children: ReactNode
  className?: string
}

export function BentoGrid({ children, className }: BentoGridProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4 max-w-[1600px] mx-auto',
        className
      )}
    >
      {children}
    </div>
  )
}

interface BentoItemProps {
  children: ReactNode
  className?: string
  colSpan?: 1 | 2 | 3 | 4 | 5 | 6
  rowSpan?: 1 | 2 | 3
}

export function BentoItem({
  children,
  className,
  colSpan = 2,
  rowSpan = 1,
}: BentoItemProps) {
  const colSpanClasses = {
    1: 'col-span-1',
    2: 'col-span-1 md:col-span-2',
    3: 'col-span-1 md:col-span-2 lg:col-span-3',
    4: 'col-span-1 md:col-span-4',
    5: 'col-span-1 md:col-span-4 lg:col-span-5',
    6: 'col-span-1 md:col-span-4 lg:col-span-6',
  }

  const rowSpanClasses = {
    1: 'row-span-1',
    2: 'row-span-1 md:row-span-2',
    3: 'row-span-1 md:row-span-3',
  }

  return (
    <div className={cn(colSpanClasses[colSpan], rowSpanClasses[rowSpan], 'bento-item', className)}>
      {children}
    </div>
  )
}

